import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { formatBlogEntryTimestamp } from '../../../../modules/datetime';
import EditableRichText from '../../../../src/web/containers/EditableRichText';
import { titleCase } from '../../../../src/shared/format';
import MediaGalleryImage from '../../../../modules/react/containers/MediaGalleryImage';
import style from './styles.scss';

const propTypes = {
  blogSettings: PropTypes.shape({
    title: PropTypes.string,
  }),
  post: PropTypes.shape({
    author: PropTypes.string,
    id: PropTypes.string.isRequired,
    snippet: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.object,
    category: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
    }),
    mediumId: PropTypes.string,
  }),
};

const defaultProps = {
  blogSettings: undefined,
  post: undefined,
};

const BlogPost = ({
  blogSettings: { title }, post,
}) => (
  <div>
    <h1 className="color-primary-foreground">
      {post.title}
    </h1>
    {post.category && (
      <p className={`bold ${style.categoryLink}`}>
        <a href={`/blog/category/${post.category.slug}`}>
          {titleCase(post.category.name)}
        </a>
      </p>
    )}
    <br />
    <p>
      {post.author || '—'}
      <br />
      {formatBlogEntryTimestamp(post.date)}
    </p>
    <br />
    {post.mediumId && (
      <MediaGalleryImage mediumId={post.mediumId} setMaxWidth className={style.image} />
    )}
    <EditableRichText
      editorKey="blog-post"
      rawContentState={post.content}
    />
    <br />
    <hr />
    <a href="/blog" className={`${style.homeLink} color-primary-foreground color-primary-border-hover`}>
      {title}
    </a>
  </div>
);

BlogPost.propTypes = propTypes;
BlogPost.defaultProps = defaultProps;

BlogPost.fragments = {
  settings: gql`
    fragment BlogPostBlogSettings on Site {
      blogSettings{
        title
      }
    }
  `,
  posts: gql`
    fragment BlogPostBlogPost on BlogPost {
      author
      snippet
      slug
      date
      title
      content
      category {
        id
        name
        slug
      }
      mediumId
    }
  `,
};
export default BlogPost;
